import { Container } from "./styles";

import reactIcon from "../../assets/lang_icons/react-icon.svg";
import linkedin from "../../assets/contact_icons/linkedin.svg";
import githubIcon from "../../assets/contact_icons/github.svg";
import whatsapp from "../../assets/contact_icons/whatsapp.svg";
import telegram from "../../assets/contact_icons/telegram.svg";
import instagramIcon from "../../assets/contact_icons/instagram.svg";
// import discordIcon from '../../assets/discord.png'

export function Footer() {
  return (
    <Container className="footer">
      {/* <a href="#" className="logo">
        <span>Tilak Ved</span>
      </a> */}
      <div>
        <p>
          This Website was made with <img src={reactIcon} alt="React" />
        </p>
      </div>

      <div className="social-media">
        <a
          href="https://www.linkedin.com/in/tilakved"
          target="_blank"
          rel="noreferrer"
        >
          <img src={linkedin} alt="Linkedin" />
        </a>
        <a
          href="https://github.com/tilakved"
          target="_blank"
          rel="noreferrer"
        >
          <img src={githubIcon} alt="GitHub" />
        </a>
        <a
          href="https://api.whatsapp.com/send/?phone=%2B919484883898&text=Hello+Tilak"
          target="_blank"
          rel="noreferrer"
        >
          <img src={whatsapp} alt="Whatsapp" />
        </a>
        <a href="https://t.me/tilakved3898" target="_blank" rel="noreferrer">
          <img src={telegram} alt="telegram" />
        </a>
        <a
          href="https://www.instagram.com/tilakved_3898?igsh=MTBnejNjbjg3MHI2aQ%3D%3D&utm_source=qr"
          target="_blank"
          rel="noreferrer"
        >
          <img src={instagramIcon} alt="Instagram" />
        </a>
      </div>
    </Container>
  );
}
